import { Link } from 'react-router-dom';

/**
 * Paslaugos taisyklės (draft — legal review pending before public go-live).
 * Minimal, honest, outcome-language. The binding legal texts live on
 * integravizija.lt; this page exists so the app itself never links to nothing.
 */
export default function Taisykles() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto bg-white rounded-xl border border-gray-200 p-8 space-y-5">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">Paslaugos taisyklės</h1>
          <Link to="/" className="text-sm text-primary-600 hover:text-primary-800">← A5Suite</Link>
        </div>

        <section className="space-y-2 text-sm text-gray-700 leading-relaxed">
          <p>
            <strong>Paslaugos teikėjas:</strong> MB „Integra vizija“ (306998587),
            V. Krėvės pr. 80B-37, LT-50385 Kaunas, info@integravizija.lt.
          </p>
          <p>
            <strong>Kas tai:</strong> A5Suite — apskaitos darbo aplinka, kurioje
            sistemos pasiūlymus (atpažintus dokumentus, paruoštus įrašus, priminimus)
            visada patvirtina apskaitininkas. Sistema neįrašo nieko į apskaitą be
            jūsų patvirtinimo.
          </p>
          <p>
            <strong>Duomenys:</strong> paslaugai teikti apdorojame jūsų įmonės
            apskaitos duomenis, kuriuos pateikiate prisijungę. Išsamesnė informacija —
            Privatumo pranešime.
          </p>
          <p>
            <strong>Atsakomybė:</strong> apskaitos teisingumo atsakomybė lieka
            apskaitininkui; paslauga teikia priemones ir priminimus, bet kiekvienas
            įrašas sukuriamas ar patvirtinamas asmens, kuris juo pasitiki.
          </p>
          <p>
            <strong>Kainos ir mokėjimas:</strong> nustatomi paslaugos sutartyje arba
            integravizija.lt paskyroje.
          </p>
          <p className="text-xs text-gray-400">
            Šios taisyklės yra ruošiamos galutiniam tekstui; galiojanti sutartis ir
            teisiniai dokumentai skelbiami integravizija.lt.
          </p>
        </section>

        <div className="text-sm">
          <Link to="/privatumas" className="text-primary-600 hover:text-primary-800">
            Privatumo pranešimas →
          </Link>
        </div>
      </div>
    </div>
  );
}
